import { render, staticRenderFns } from "./ShiftComponent.vue?vue&type=template&id=deae528e&scoped=true&"
import script from "./ShiftComponent.vue?vue&type=script&lang=js&"
export * from "./ShiftComponent.vue?vue&type=script&lang=js&"
import style0 from "./ShiftComponent.vue?vue&type=style&index=0&id=deae528e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deae528e",
  null
  
)

export default component.exports